// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3CemL","inlineContent":"_3K7uv","pageWrapper":"Ry26q"};